import styled from 'styled-components';
import color from '../../../config/colors.json';

export const TextInfo = styled.span`
    color: ${color.lightGrey12};
    font-size: 10px;
    line-height: 15px;
    margin-top: 5px;
    font-family: 'Poppins', sans-serif;
`;

export const LocationCardText = styled.span`
    color: ${color.light};
    font-size: 12px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    line-height: 14px;
    margin-right: 8px;
`;

export const CloseButton = styled.button`
    background-color: transparent;
    padding: 0;
    border: 0 solid transparent;
    color: ${color.light};
    outline: 0;
    position: relative;
    svg {
        fill: ${color.light}
    }
`;

export const LocationList = styled.div`
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    min-height: 58px;
`;

export const LocationItem = styled.div`
    align-items: center;
`;

export const CardContainer = styled.div`
    width: 100%;
    background-color: red;
    &:not(:last-child) {
        padding: 0 10px 0 0;
    }
`;

export const InputContainer = styled.div`
    position: relative;
`;

export const Input = styled.input`
    display: block;
    width: 462px;
    height: 27.27px;
    font-family: 'Poppins', sans-serif;
    border-radius: 5px;
    border: none;
    border-bottom: 1px solid ${color.lightGrey9};
    font-size: 17px;
    line-height: 20px;
    padding: 10px 0;
    &:focus {
        outline: 0;
    }
`;

export const Question = styled.span`
    font-family: 'Poppins', sans-serif;
    color: ${color.dark};
    font-size: 15px;
    margin-bottom: 25px;
    font-weight: 600;
`;

export const Icon = styled.div`
    svg {
        fill: ${color.grey};
        width: 20px;
        height: 20px;
        margin-left: -20px;
    }
`;

export const Prediction = styled.ul`
    position: absolute;
    margin: 0;
    padding: 0;
    top: 100%;
    width: 100%;
    border: 1px solid ${color.lightGrey9};
    background-color: ${color.light};
    list-style: none;
    z-index: 3;
    max-height: 300px;
    overflow: auto;
    border-radius: 5px;
    & li {
        &:not(:last-child) {
            border-bottom: 1px solid rgba(0,0,0,.05);
        }
        & button {
            background-color: transparent;
            border: none;
            width: 100%;
            padding: 10px 5px; 
            text-align: left;
            font-family: 'Poppins', sans-serif;
            font-size: 14px;
            &:focus {
                outline: 0;
            }
        }
    }
`;
